import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import {
  PatientGroup,
  PatientGroupProps,
} from 'src/app/data/dietitian/domain/patient_group/patient_group';
import { ConfirmationModalComponent } from 'src/app/ui/components/confirmation-modal/confirmation-modal.component';

import UniqueEntityID from '../../../../core/domain/unique_entity_id';
import { EditPatientGroupModalComponent } from './components/edit-patient-group-modal/edit-patient-group-modal.component';
import { PatientGroupsFacade } from './patient-groups.facade';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-patient-groups',
  templateUrl: './patient-groups.component.html',
  styleUrls: ['./patient-groups.component.scss'],
  providers: [PatientGroupsFacade],
})
export class PatientGroupsComponent implements OnInit {
  selectedPatientGroup: string | undefined;
  editing: boolean;
  bsModalRef?: BsModalRef;

  constructor(
    private facade: PatientGroupsFacade,
    private modalService: BsModalService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
    // do nothing
  }

  ngOnInit(): void {
    firstValueFrom(this.activatedRoute.queryParams).then((params) => {
      if (params['create']) {
        this.showPatientGroupEditionModal();
      }
    });
  }

  selectPatientGroup(patientGroup?: PatientGroup) {
    if (this.editing) return;
    console.log('👀 selectPatientGroup', patientGroup?.id.toString());
    this.selectedPatientGroup = patientGroup?.id.toString() ?? undefined;
  }

  onEdit(editing: boolean) {
    this.editing = editing;
  }

  showPatientGroupEditionModal(patientGroup?: PatientGroup) {
    this.router
      .navigate([], {
        queryParams: {
          create: true,
        },
        queryParamsHandling: 'merge',
      })
      .then();

    const initialState: ModalOptions = {
      class: 'modal-xl modal-dialog-centered',
      initialState: {
        patientGroup: patientGroup
          ? patientGroup
          : PatientGroup.create(
              {} as PatientGroupProps,
              new UniqueEntityID('_NEW_'),
            ),
      },
    };
    this.bsModalRef = this.modalService.show(
      EditPatientGroupModalComponent,
      initialState,
    );
  }

  showPatientGroupDeletionModal(patientGroup: PatientGroup) {
    const initialState: ModalOptions = {
      class: 'modal-md modal-dialog-centered',
      initialState: {
        title: `Supprimer le groupe "${patientGroup.name}" ?`,
        subtitle: 'Attention cette action est irréversible.',
      },
    };
    this.bsModalRef = this.modalService.show(
      ConfirmationModalComponent,
      initialState,
    );
    if (this.bsModalRef.content instanceof ConfirmationModalComponent) {
      this.bsModalRef.content.validate.subscribe(() =>
        this.deletePatientGroup(patientGroup.id.toString()),
      );
    }
  }

  async deletePatientGroup(patientGroupId: string): Promise<void> {
    if (patientGroupId == this.selectedPatientGroup) {
      this.selectPatientGroup();
    }
    await this.facade.deletePatientGroup(patientGroupId);
  }
}
